/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MagicToken
 */
export interface MagicToken {
    /**
     * The unique identifier of the magic token.
     * @type {string}
     * @memberof MagicToken
     */
    id: string;
    /**
     * The date the magic token was created.
     * @type {Date}
     * @memberof MagicToken
     */
    createdDate: Date;
    /**
     * Whether the magic token has been used.
     * @type {boolean}
     * @memberof MagicToken
     */
    used: boolean;
    /**
     * The date the magic token was used, or null if not yet used.
     * @type {Date}
     * @memberof MagicToken
     */
    usedDate?: Date;
}

/**
 * Check if a given object implements the MagicToken interface.
 */
export function instanceOfMagicToken(value: object): value is MagicToken {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    if (!('used' in value) || value['used'] === undefined) return false;
    return true;
}

export function MagicTokenFromJSON(json: any): MagicToken {
    return MagicTokenFromJSONTyped(json, false);
}

export function MagicTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): MagicToken {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdDate': (new Date(json['createdDate'])),
        'used': json['used'],
        'usedDate': json['usedDate'] == null ? undefined : (new Date(json['usedDate'])),
    };
}

export function MagicTokenToJSON(json: any): MagicToken {
    return MagicTokenToJSONTyped(json, false);
}

export function MagicTokenToJSONTyped(value?: MagicToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdDate': value['createdDate'].toISOString(),
        'used': value['used'],
        'usedDate': value['usedDate'] == null ? value['usedDate'] : value['usedDate'].toISOString(),
    };
}

